'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Used to mark a paragraph as verse
 * @constant
 * @type {string}
 */
var VERSE = exports.VERSE = 'verse';

/**
 * Used to mark a paragraph as chorus
 * @constant
 * @type {string}
 */
var CHORUS = exports.CHORUS = 'chorus';

/**
 * Used to mark a paragraph as not containing a line marked with a type
 * @constant
 * @type {string}
 */
var NONE = exports.NONE = 'none';

/**
 * Used to mark a paragraph as containing lines with both verse and chorus type
 * @constant
 * @type {string}
 */
var INDETERMINATE = exports.INDETERMINATE = 'indeterminate';


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/constants.js
// module id = 31
// module chunks = 1